<div fxLayoutAlign="center center" fxLayout="column" class="mat-typography">
  <div class="dialog-header" fxLayoutAlign="start center">
    <h3 mat-dialog-title>{{ heading }}</h3>
  </div>
  <div class="dialog-footer" fxLayout="row" fxLayoutAlign="center center">
    <button mat-button (click)="dialogRef.close(false)">{{ noLabel }}</button>
    <button mat-raised-button (click)="dialogRef.close(true)">
      {{ yesLabel }}
    </button>
  </div>
</div>
